/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class  InternationalizationService {


    getLocale(){
        return (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
    };

    getTranslations(){
        ApplicationServices.call(Constants.GET_TRANSLATIONS , {language:this.getLocale() , applicationDefault:'en'}).then(function(response){
            Action.update(Constants.ON_TRANSLATION_UPDATE , response.translations);
            return response.translations
        });
    };

    getCountries(){
        ApplicationServices.call(Constants.GET_COUNTRIES , {}).then(function(response){
            Action.update(Constants.GET_COUNTRIES , response.countries);
            return response.countries
        });
    }

    getModuleTranslations(){
        ApplicationServices.call(Constants.GET_MODULE_TRANSLATIONS , {language:this.getLocale()}).then(function(response){
            Action.update(Constants.GET_MODULE_TRANSLATIONS , response.translations);
            return response.translations
        });
    }
}

export default new InternationalizationService();